/**
 * Swap Instant CDN images for English Shopify files on EN storefronts.
 * Registry: window.__instantLocalizedImages (set in instant-localized-images-config.liquid).
 */
(function () {
  const WIDTHS = [360, 640, 750, 828, 1080, 1280];
  const DATA_ATTR = 'data-instant-localized';

  function languageCode() {
    return (document.documentElement.getAttribute('lang') || 'nl').split('-')[0].toLowerCase();
  }

  function registry() {
    return window.__instantLocalizedImages || null;
  }

  function matchInstantKey(url) {
    if (!url) return null;
    const map = registry();
    if (!map) return null;

    for (const key of Object.keys(map)) {
      if (url.indexOf(key) !== -1) return key;
    }
    return null;
  }

  function buildSrcset(baseUrl) {
    const sep = baseUrl.indexOf('?') === -1 ? '?' : '&';
    return WIDTHS.map(function (width) {
      return baseUrl + sep + 'width=' + width + ' ' + width + 'w';
    }).join(', ');
  }

  function swapImage(img) {
    if (!img || img.getAttribute(DATA_ATTR) === 'en') return;

    const key =
      matchInstantKey(img.getAttribute('src') || '') ||
      matchInstantKey(img.getAttribute('srcset') || '');
    if (!key) return;

    const baseUrl = registry()[key];
    if (!baseUrl) return;

    const sep = baseUrl.indexOf('?') === -1 ? '?' : '&';
    img.src = baseUrl + sep + 'width=1280';
    img.srcset = buildSrcset(baseUrl);
    img.setAttribute(DATA_ATTR, 'en');
  }

  function processRoot(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('img').forEach(swapImage);
  }

  function init() {
    if (languageCode() !== 'en') return;
    if (!registry()) return;

    processRoot(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.tagName === 'IMG') {
            swapImage(node);
            return;
          }
          processRoot(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
